import { Button, Card, Modal } from "react-bootstrap";
import styled from "styled-components";
import { APP_COLORS } from "../witadmin/Common/constants";

export const StyledCard = styled(Card)`
  font-size: 14px;
`;

export const StyledModalHeader = styled(Modal.Header)`
  background-color: ${({ theme }) => theme.greyBackground};
`;

export const StyledModalBody = styled(Modal.Body)`
  background-color: ${({ theme }) => theme.greyBackground};
  max-height: 160px;
  height: 160px;
`;

export const StyledModalCloseButton = styled(Button)`
  background-color: #656565 !important;
`;

export const StyledSpinner = styled.i`
  .fa-spin {
    animation: spin 1000ms infinite linear;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`;

export const StyledModal = styled(Modal)`
  .modal-body {
    min-height: 160px;
  }
`;

export const StyledGoBackButton = styled(Button)`
  background-color: ${APP_COLORS["gray"]} !important;
  color: #656565;

  &:hover {
    background-color: ${APP_COLORS["gray-darkish"]};
    border: 1px solid ${APP_COLORS["gray-darkish"]};
    color: ${APP_COLORS["gray-dark"]};
  }

  &:focus {
    background-color: ${APP_COLORS["gray-dark"]} !important;
    border: 1px solid ${APP_COLORS["gray-dark"]} !important;
  }
`;
